import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i-1656173275__a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M8 0C6.896 0 5.86.208 4.89.625c-.979.417-1.83.987-2.554 1.71A8.005 8.005 0 0 0 .625 4.892 7.785 7.785 0 0 0 0 8c0 1.104.208 2.14.625 3.11.417.979.987 1.83 1.71 2.554a8.006 8.006 0 0 0 2.556 1.711A7.785 7.785 0 0 0 8 16c1.104 0 2.14-.208 3.11-.625a8.007 8.007 0 0 0 2.554-1.71 8.007 8.007 0 0 0 1.711-2.556A7.785 7.785 0 0 0 16 8c0-1.104-.208-2.14-.625-3.11a8.006 8.006 0 0 0-1.71-2.554A8.006 8.006 0 0 0 11.108.625 7.785 7.785 0 0 0 8 0Zm0 14.969a6.74 6.74 0 0 1-2.703-.547 7.142 7.142 0 0 1-2.219-1.492 6.981 6.981 0 0 1-1.5-2.211A6.78 6.78 0 0 1 1.031 8c0-.958.183-1.86.547-2.703A7.141 7.141 0 0 1 3.07 3.078a6.981 6.981 0 0 1 2.211-1.5A6.78 6.78 0 0 1 8 1.031c.958 0 1.86.183 2.703.547a7.14 7.14 0 0 1 2.219 1.492 6.981 6.981 0 0 1 1.5 2.211A6.78 6.78 0 0 1 14.969 8a6.74 6.74 0 0 1-.547 2.703 7.141 7.141 0 0 1-1.492 2.219 6.982 6.982 0 0 1-2.211 1.5A6.78 6.78 0 0 1 8 14.969Zm3.063-9.203L8.828 8l2.235 2.234a.37.37 0 0 1 .109.274c0 .11-.037.2-.11.273l-.28.281a.37.37 0 0 1-.274.11.37.37 0 0 1-.274-.11L8 8.829l-2.234 2.235a.371.371 0 0 1-.274.109c-.11 0-.2-.037-.273-.11l-.282-.28a.37.37 0 0 1-.109-.274c0-.11.037-.2.11-.274L7.171 8 4.938 5.766a.371.371 0 0 1-.11-.274c0-.11.037-.2.11-.273l.28-.282a.371.371 0 0 1 .274-.109c.11 0 .2.037.274.11L8 7.171l2.234-2.234a.37.37 0 0 1 .274-.11c.11 0 .2.037.273.11l.281.28c.073.074.11.165.11.274 0 .11-.037.2-.11.274Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-1656173275__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }